'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_sjs_js_WrappedDictionary$Cache$() {
  this.tM = null;
  $n_sjs_js_WrappedDictionary$Cache$ = this;
  this.tM = Object.prototype.hasOwnProperty;
}
export { $c_sjs_js_WrappedDictionary$Cache$ as $c_sjs_js_WrappedDictionary$Cache$ };
$p = $c_sjs_js_WrappedDictionary$Cache$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_sjs_js_WrappedDictionary$Cache$;
/** @constructor */
function $h_sjs_js_WrappedDictionary$Cache$() {
}
export { $h_sjs_js_WrappedDictionary$Cache$ as $h_sjs_js_WrappedDictionary$Cache$ };
$h_sjs_js_WrappedDictionary$Cache$.prototype = $p;
var $d_sjs_js_WrappedDictionary$Cache$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_sjs_js_WrappedDictionary$Cache$, "scala.scalajs.js.WrappedDictionary$Cache$", ({
  vW: 1
}));
export { $d_sjs_js_WrappedDictionary$Cache$ as $d_sjs_js_WrappedDictionary$Cache$ };
var $n_sjs_js_WrappedDictionary$Cache$;
function $m_sjs_js_WrappedDictionary$Cache$() {
  if ((!$n_sjs_js_WrappedDictionary$Cache$)) {
    $n_sjs_js_WrappedDictionary$Cache$ = new $c_sjs_js_WrappedDictionary$Cache$();
  }
  return $n_sjs_js_WrappedDictionary$Cache$;
}
export { $m_sjs_js_WrappedDictionary$Cache$ as $m_sjs_js_WrappedDictionary$Cache$ };
